var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { on: { enter: _vm.getSearchList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-plant", {
                  attrs: { type: "edit", name: "plantCd" },
                  model: {
                    value: _vm.searchParam.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "plantCd", $$v)
                    },
                    expression: "searchParam.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-select", {
                  attrs: {
                    comboItems: _vm.useFlagItems,
                    type: "search",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "useFlag",
                    label: "LBLUSEFLAG",
                  },
                  model: {
                    value: _vm.searchParam.useFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "useFlag", $$v)
                    },
                    expression: "searchParam.useFlag",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
          [
            _c(
              "c-table",
              {
                ref: "processTable",
                attrs: {
                  title: "LBL0001702",
                  columns: _vm.grid.columns,
                  data: _vm.grid.data,
                  columnSetting: false,
                  isFullScreen: false,
                  usePaging: false,
                  filtering: false,
                  expandAll: true,
                },
                on: { rowClick: _vm.rowClick },
              },
              [
                _c(
                  "template",
                  { slot: "table-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _c("c-btn", {
                          attrs: { label: "LBLSEARCH", icon: "search" },
                          on: { btnClicked: _vm.getSearchList },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9" },
          [
            _c("c-tab", {
              attrs: {
                type: "tabcard",
                tabItems: _vm.tabItems,
                inlineLabel: true,
                align: "left",
              },
              on: {
                "update:tabItems": function ($event) {
                  _vm.tabItems = $event
                },
                "update:tab-items": function ($event) {
                  _vm.tabItems = $event
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (tab) {
                    return [
                      tab.name == "processDetail"
                        ? _c(tab.component, {
                            ref: "processDetail",
                            tag: "component",
                            attrs: { parentProcessCd: _vm.selectedProcessCd },
                            on: {
                              searchDetail: _vm.getProcessList,
                              isNew: _vm.reset,
                            },
                          })
                        : _c(tab.component, {
                            ref: "processUnit",
                            tag: "component",
                            attrs: { parentProcess: _vm.selectedProcess },
                            on: {
                              searchDetail: _vm.getProcessList,
                              isNew: _vm.reset,
                            },
                          }),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }